import * as React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Area } from "../../../models/Area";
import { LicenseType } from "../../../models/LicenseType";
import { SilSolverClient } from "../../../models/SilSolverClient";
import { UserArea } from "../../../models/UserArea";
import { UserDetails } from "../../../models/UserDetails";
import { AreaType } from "../../../models/AreaTypeEnum";
import { AreaWithProjectName } from "../../../models/AreaWithProjectName";
import { hasViewAreasAccess } from "../shared/helpers";
import { Profile } from "../../../models/Profile";

interface Props {
  users: { [userId: number]: UserDetails };
  userAreas: UserArea[];
  areas: AreaWithProjectName[];
  onSelectUserRow: ((user: UserDetails) => void);
  userProfile: Profile;
}

interface State {
  //userAreas: UserArea[];
  //areas: Area[];
  clients: SilSolverClient[];
  selectedAreaType: AreaType;
  availableAreaTypes: AreaType[];
}

export class UsersTable extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      //userAreas: [],
      //areas: [],
      clients: [],
      selectedAreaType: AreaType.Clients,
      availableAreaTypes: [
        AreaType.Clients,
        AreaType.Regions,
        AreaType.Locations,
        AreaType.Units,
        AreaType.Projects
      ]
    };
  }

  _getAreaWithDescendentAreas = (area: AreaWithProjectName): AreaWithProjectName[] => {
    var areas = [];
    areas.push(area);
    if (area.isClient) {
      return this.props.areas.filter(a => a.parentClientId == area.id);
    }
    if (area.isRegion) {
      return this.props.areas.filter(a => a.parentRegionId == area.id);
    }
    if (area.isLocation) {
      return this.props.areas.filter(a => a.parentLocationId == area.id);
    }
    if (area.isUnit) {
      return this.props.areas.filter(a => a.parentUnitId == area.id);
    }
    if (area.isProject) {
      return this.props.areas.filter(a => a.projectId == area.id)
    }
  }

  _getAreasStrings = user => {
    if (!hasViewAreasAccess(this.props.userProfile)) {
      return null;
    }

    var userAreasMatches = this.props.userAreas.filter(
      ua => ua.userId == user.userID
    );

    var currentAreas = this.props.areas.filter(a => userAreasMatches.find(ua => ua.areaId == a.id));
    if (!currentAreas.length) {
      return null;
    }

    let areasNames = new Set<string>();

    for (let i = 0; i < currentAreas.length; i++) {
      var currentArea = currentAreas[i];
      var areas = this._getAreaWithDescendentAreas(currentArea);
      var filteredAreas: string[] = [];
      if (this.state.selectedAreaType == AreaType.Clients) {
        filteredAreas = areas.filter(a => a.isClient).map(a => a.clientId);
      } else if (this.state.selectedAreaType == AreaType.Regions) {
        filteredAreas = areas.filter(a => a.isRegion).map(a => a.region);
      } else if (this.state.selectedAreaType == AreaType.Locations) {
        filteredAreas = areas.filter(a => a.isLocation).map(a => a.location);
      } else if (this.state.selectedAreaType == AreaType.Units) {
        filteredAreas = areas.filter(a => a.isUnit).map(a => a.unit);
      } else if (this.state.selectedAreaType == AreaType.Projects) {
        filteredAreas = areas.filter(a => a.isProject).map(a => a.projectName);
      }

      for (var filteredArea of filteredAreas) {
        areasNames.add(filteredArea);
      }
    }


    return Array.from(areasNames).filter(an => an.length).join(", ");
  };

  componentDidMount() {
    //AdminApiController.getAreas()
    //  .then(areas => this.setState({ areas }));
    //AdminApiController.getUserAreas()
    //  .then(userAreas => this.setState({ userAreas }));
  }

  AreaTypeOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({
      selectedAreaType: parseInt(event.target.value)
    })
  }

  render() {
    var tblData = [];
    for (let id in this.props.users) {
      const user = this.props.users[id];
      var tblUser = { ...user };
      tblUser["clients"] = this._getAreasStrings(user);
      tblData.push(tblUser);
    }
    //this.props.users.forEach(user => {
    //  var tblUser = Object.assign({}, user);
    //  tblUser["clients"] = this._getClientsStrings(user);
    //  tblData.push(tblUser);
    //});

    const columns = [
      {
        dataField: "userName",
        text: "Username",
        sort: true,
        //filter: textFilter({ placeholder: "Search", className: "search" })
      },
      {
        dataField: "name",
        text: "Name",
        sort: true /*,*/
        //filter: textFilter({ placeholder: 'Search', className: 'search' })
      },
      {
        dataField: "email",
        text: "Email",
      },
      {
        dataField: "designation",
        text: "Designation",
        sort: true
      },
      {
        dataField: "profile.name",
        text: "Profile",
        sort: true
      },
      {
        dataField: "clients",
        text: AreaType[this.state.selectedAreaType],
        sort: true
      },
      {
        dataField: "license",
        formatter: (cell, row) => LicenseType[cell],
        text: "License",
        sort: true
      }
    ];

    const defaultSortedBy = [
      {
        dataField: "name",
        order: "asc"
      }
    ];

    const selectRow = {
      mode: "radio",
      clickToSelect: true,
      bgColor: "#00BFFF",
      hideSelectColumn: true,
      onSelect: (row, isSelect, rowIndex, e) => {
        var user = this.props.users[row.userID];
        this.props.onSelectUserRow(user);
      }
    };

    const { SearchBar, ClearSearchButton } = Search;

    return (
      <div style={{ display: "flex", flexDirection: "column", minWidth: "700px" }}>
        <ToolkitProvider
          keyField="userId"
          data={tblData}
          columns={columns}
          bootstrap4
          search
        >
          {props => (
            <React.Fragment>
              <div style={{ display: "flex" }}>
                <h2>Users table</h2>
                <div style={{ padding: "5px 5px 0px" }}>
                  <div>
                    <select style={{ display: "inline-block" }} value={this.state.selectedAreaType} onChange={(val) => this.AreaTypeOnChange(val)} className="form-control">
                      {Object.keys(this.state.availableAreaTypes).map(key => (
                        <option
                          key={key}
                          value={key}
                        >
                          {AreaType[key]}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div style={{ paddingTop: "5px" }}>
                  <SearchBar {...props.searchProps} />
                </div>
                <div>
                  <ClearSearchButton {...props.searchProps} />
                </div>
              </div>
              <hr />
              <BootstrapTable
                {...props.baseProps}
                keyField="userID"
                data={tblData}
                columns={columns}
                defaultSorted={defaultSortedBy}
                bootstrap4={true}
                hover
                selectRow={selectRow}
                scrollY
                maxHeight="20vh"
                striped
              />
            </React.Fragment>
          )}
        </ToolkitProvider>
      </div>
    );
  }
}
